import { sharedEn } from './pages/shared'
import { sendSmsEn } from './pages/sendSms'
import { dashboardEn } from './pages/dashboard'
import { smsSearchEn } from './pages/smsSearch'
import { realTimeProgressEn } from './pages/realTimeProgress'
import { exportRecordsEn } from './pages/exportRecords'
import { platformSettingsEn } from './pages/platformSettings'
import { apiKeysEn } from './pages/apiKeys'
import { apiDocsEn } from './pages/apiDocs'
import { accountEn } from './pages/account'

export default {
  lang: {
    zhCN: '简体中文',
    enUS: 'English',
    jaJP: '日本語',
    select: 'Language',
  },
  menu: {
    dashboard: 'Dashboard',
    sendSms: 'Send SMS',
    realTimeProgress: 'Live Progress',
    pendingQueue: 'Pending Queue',
    smsSearch: 'SMS Search',
    exportRecords: 'Export Records',
    apiIntegration: 'API Integration',
    apiDocs: 'API Docs',
    apiKeys: 'Keys & Callbacks',
    platformSettings: 'Settings',
  },
  nav: {
    overview: 'Overview',
    smsService: 'SMS Services',
    development: 'Developer',
    developConfig: 'Developer & Config',
    collapseSidebar: 'Collapse Sidebar',
    efficientReach: 'Fast Delivery',
    efficientReachDesc: 'Global SMS in seconds',
  },
  layout: {
    balance: 'Balance',
    accountSettings: 'Account Settings',
    accountSettingsDesc: 'Password & email',
    logout: 'Sign Out',
    logoutConfirm: 'Confirm Sign Out',
    logoutConfirmText: 'Are you sure you want to sign out?',
    cancel: 'Cancel',
    confirm: 'Sign Out',
    online: 'Online',
  },
  login: {
    badge: 'Global SMS Network',
    heroTitle: 'Connect Globally',
    heroAccent: 'Deliver Instantly',
    heroDesc: '{site} provides secure, low-latency cross-border messaging for OTP, marketing, and notifications.',
    statCountries: 'Countries',
    statUptime: 'Uptime',
    statDelivery: 'Avg. Delivery',
    username: 'Username',
    password: 'Password',
    captcha: 'Captcha',
    usernamePlaceholder: 'Enter username',
    passwordPlaceholder: 'Enter password',
    captchaPlaceholder: 'Enter captcha',
    submit: 'Enter Console',
    submitting: 'Signing in…',
    portalFail: 'Portal login failed, please sign in manually',
    required: 'Please enter username and password',
    fail: 'Sign in failed',
    footer: '© {year} {site}',
  },
  common: {
    loading: 'Loading…',
    save: 'Save',
    close: 'Close',
    search: 'Search',
    reset: 'Reset',
    export: 'Export',
    refresh: 'Refresh',
    total: '{n} records',
    noData: 'No data',
    success: 'Success',
    failed: 'Failed',
    networkError: 'Network error, please check your connection',
    timeout: 'Request timed out',
    sessionExpired: 'Session expired',
    unknown: 'Unknown',
  },
  badge: {
    marketing: 'Marketing',
  },
  shared: sharedEn,
  sendSms: sendSmsEn,
  dashboard: dashboardEn,
  smsSearch: smsSearchEn,
  realTimeProgress: realTimeProgressEn,
  exportRecords: exportRecordsEn,
  platformSettings: platformSettingsEn,
  apiKeys: apiKeysEn,
  apiDocs: apiDocsEn,
  account: accountEn,
}
